// const originStr = "https://www.oesa.de";
// const originStr = "http://localhost:8080";
// const originStr = "https://www.oeffentliche.de/";
// const originStr = "https://4g.cleverads.de/";
const postMessageTypeStr = "iframeDataLayerPushEvent";

/* const createJsonEventStr = (action, label) => {
  return JSON.stringify({
    eventType: postMessageTypeStr,
    data: {
      event: "appEvent",
      "data-event-category": "deinDing-Online",
      "data-event-action": action,
      "data-event-label": label
    }
  });
}; */

export const postGaMessage = (action, label) => {
  // console.log("postGaMessage mit action = " + action + " und label = " + label);

  // window.parent.postMessage(createJsonEventStr(action, label), window.origin);
  // Die Initialisierung des dataLayers habe ich hinzugefügt, für den Fall, dass das
  // Script aus der index.html noch nicht geladen ist.
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "appEvent",
    "data-event-category": "deinDing-Online",
    "data-event-action": action,
    "data-event-label": label,
    topOrigin: "https://www.oeffentliche.de" // Wichtig: Muss mit der im Skript definierten originStr übereinstimmen
  });
};
